module.exports = __webpack_public_path__ + "media/images/svg/down-arrow-5afbd73fa0afafb1d691e2f26e2ac8c7.svg";